@if (productName(); as productName) {
  @if (asset().filename.includes('mp4')) {
    <video [src]="asset().filename" #videoEl loop muted playsinline disablepictureinpicture="true"></video>
  } @else {
    <img
      [src]="asset().filename | storyblokCdn"
      [attr.width]="dimensions().width"
      [attr.height]="dimensions().height"
      alt=""
    />
  }
  <div class="dialog">
    <app-badge icon="/assets/icons/up-arrow.svg" color="primary">{{ productName | productNameShort }}</app-badge>
    <h1>{{ title() }}</h1>
    <p [innerHTML]="description() | storyblokRichText"></p>
    <button
      appButton
      name="confirm"
      location="feature-paywall-dialog"
      [analyticsExtra]="{ scope: scope() }"
      [color]="'primary'"
      weight="bold"
      shape="round"
      height="4"
      spacing="5"
      shape="round"
      size="3"
      [center]="true"
      (click)="confirm()"
    >
      @if (canStartTrial()) {
        Start Free Trial
      } @else {
        Upgrade Now
      }
    </button>
  </div>
}
